import { render, staticRenderFns } from "./PageUpsellConfirmPayment.vue?vue&type=template&id=163c6ee8"
import script from "./PageUpsellConfirmPayment.vue?vue&type=script&lang=js"
export * from "./PageUpsellConfirmPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports